import { createFileRoute, Outlet, redirect } from "@tanstack/solid-router"
import z from "zod"
import { orpc } from "~/lib/orpc"

export const Route = createFileRoute("/_auth")({
  validateSearch: z.object({ redirect: z.string().optional() }),
  beforeLoad: async ({ search, context }) => {
    const session = await context.queryClient.ensureQueryData(orpc.auth.getSession.queryOptions())

    if (session) {
      if (search.redirect) {
        throw redirect({ to: search.redirect })
      }
      throw redirect({ to: "/" })
    }
  },
  component: () => <Outlet />
})
